import Entity from '../entity';

export default class BankPosAccount extends Entity<string> {
  bankName: string;
  currencyId: string;
  isDefault: boolean;
  isActive: boolean;
  limit: number;
}
